import { Model } from 'pinia-orm';

export default class JobFunction extends Model {
    static get entity() {
        return 'functions'
    }

    static fields() {
        return {
            id: this.uid(),
            city: this.attr(null),
            title: this.attr({}),
            title_translated: this.attr(''),
            published: this.attr(null),
            archived: this.attr(null),
        }
    }

    get title_lowercased() {
        return this.title_translated.toLowerCase();
    }
}
